import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'application-setting'
const initialState = {
    list: null,
}
export const search = createApiAction('application-setting/get', client.retrieve('/api/application/setting'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
        .addCase(search.fulfilled, (state, action) => {
            state.list = action.payload
        })
  },
})

export default sessionSlice.reducer
